<script setup>
import { computed } from 'vue'

defineProps({ incident: { type: Object, default: () => ({}) } })

const prettyJson = computed(() => {
  return JSON.stringify(incident, null, 2)
})
</script>

<template>
  <v-layout-card>
    <div class="w-100 px-2 d-flex flex-row justify-space-between align-center flex-wrap">
      <v-card-title>
        <v-icon
          icon="mdi-alert"
          start
        />
        {{ $t(`incidents.${incident.type}.title`) }}
      </v-card-title>

      <div class="d-flex flex-row align-center ga-2">
        <slot name="jsonButton" />
        <slot name="commentButton" />
        <slot name="assignButton" />
      </div>
    </div>
    <v-card-text class="py-2">
      <pre><code>{{ prettyJson }}</code></pre>
    </v-card-text>
    <v-card-actions class="justify-end">
      <slot name="genericActions" />
    </v-card-actions>
  </v-layout-card>
</template>
